import './HypoparaAssociationCard.scss';

import { faArrowUpRightFromSquare, faHeart } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const HypoparaAssociationCard = () => (
  <aside className='fvt-hypopara-card bg-white border rounded-3 p-4' aria-labelledby='fvt-hypopara-card-title'>
    <div className='fvt-hypopara-card__eyebrow fw-semibold text-muted text-uppercase'>
      <FontAwesomeIcon icon={faHeart} aria-hidden='true' />
      Patient advocacy partner
    </div>
    <h2 id='fvt-hypopara-card-title' className='fvt-hypopara-card__title'>
      HypoPARAthyroidism Association (HPA)
    </h2>
    <p className='text-secondary'>
      A patient-led, nonprofit organization working to improve the lives of people impacted by hypoparathyroidism
      through education, support, family genetic testing events, research, and advocacy.
    </p>
    <p className='text-secondary'>
      This is a good place to turn to for resources to learn more about ADH1, find an healthcare provider that
      understands hypoPARA, and connect with others in the community living with hypoPARA.
    </p>
    <div className='fvt-hypopara-card__cta'>
      <a href='https://www.hypopara.org/' target='_blank' rel='noopener noreferrer' className='fvt-hypopara-card__btn'>
        Visit hypopara.org
        <FontAwesomeIcon icon={faArrowUpRightFromSquare} aria-hidden='true' />
      </a>
    </div>
  </aside>
);
